import React from 'react'
import SeminarCard from 'components/seminar/SeminarCard'

const SeminarPastList = ({ data }) => {
  return (
    <ul className="seminarPastList">
      {data.map((edge, index) => {
        return (
          <li className="seminarPastList__item" key={edge?.node?.id}>
            <SeminarCard data={edge?.node} loading={index < 1 ? 'eager' : 'lazy'} />
          </li>
        )
      })}
    </ul>
  )
}

export default SeminarPastList
